import { PhotoProblemNotice } from './PhotoProblemNotice';
import { PhotoRemoveConfirm } from './PhotoRemoveConfirm';
import { PhotoUploadProgress } from './PhotoUploadProgress';
import type { PhotoLayout } from './use-photo-layout';
import type { VenuePhotoFlow } from './use-venue-photo-flow';

export interface PhotoCardStatusProps {
  readOnly: boolean;
  /** Whether an imported FareHarbor photo would show if the uploaded one were removed. */
  importedPhotoAvailable: boolean;
  layout: PhotoLayout;
  flow: VenuePhotoFlow;
}

/** Whatever needs saying under the photo: upload progress, why something failed, or a removal prompt. */
export function PhotoCardStatus({
  readOnly,
  importedPhotoAvailable,
  layout,
  flow,
}: PhotoCardStatusProps) {
  const { phase, selection } = flow;
  const confirming = !readOnly && (phase === 'confirming' || phase === 'removing');
  return (
    <>
      {phase === 'uploading' && selection && (
        <PhotoUploadProgress
          file={selection.file}
          progress={flow.progress}
          buttonHeight={layout.buttonHeight}
          onCancel={flow.cancelUpload}
        />
      )}
      <PhotoProblemNotice flow={flow} layout={layout} />
      {confirming && (
        <PhotoRemoveConfirm
          hasImportedPhoto={importedPhotoAvailable}
          busy={phase === 'removing'}
          phone={layout.phone}
          buttonHeight={layout.buttonHeight}
          focusRequested={flow.focusTarget === 'keep'}
          onFocused={flow.focusDone}
          onKeep={flow.keepPhoto}
          onRemove={() => void flow.remove()}
        />
      )}
    </>
  );
}
